
















import { Component, Prop, Mixins, Provide } from 'vue-property-decorator';
import { MixinChartGroupStandard } from '../../../plugins/podolib/services/helper/mixins/chart/standard';

@Component({
  components: {
    ChartRawPronationSupinationFeet: () => import('@/components/charts/walking/ChartRawPronationSupinationFeet.vue'),
  },
})
export default class ChartsGroupWalkingStepsFeet extends Mixins(MixinChartGroupStandard) {
  @Provide() angles: any = ['heelStrike', 'toesStrike', 'heelOff', 'toesOff'];
}
